<template>
    <v-app-bar :class="{ 'small-header': isCollapsed, 'large-header': !isCollapsed }" :collapse="isCollapsed" app
        color="secondary" flat class="main-header" @mouseover="handleMouseOver" @mouseleave="handleMouseLeave">
        <v-img class="navbar-brand important-nav-bar" alt="SQOPS" src="@/assets/img/logo-sqops.svg"
            transition="scale-transition" width="156" contain />
        <li class="nav-item" link>
            <router-link :to="{ name: 'HomeView' }" class="nav-link" :class="{ active: isActive('home') }" title="Home">
                <span class="material-icons">home</span>
                <div class="nav-text">Home</div>
            </router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'MetadataAnalysis' }" class="nav-link colorMenu"
                :class="{ active: isActive('analysis') }" title="Metadata Analysis">
                <span class="material-icons-outlined">analytics</span>
                <div class="nav-text">Metadata Analysis</div>
            </router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'FlowAnalysis' }" class="nav-link colorMenu" :class="{ active: isActive('flow') }"
                title="Flow Analysis">
                <span class="material-icons-round">account_tree</span>
                <div class="nav-text">Flow Analysis</div>
            </router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'DevelopmentQuality' }" class="nav-link colorMenu"
                :class="{ active: isActive('quality') }" title="Development Quality">
                <span class="material-icons-outlined">integration_instructions</span>
                <div class="nav-text">Development Quality</div>
            </router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'AMC' }" class="nav-link colorMenu" :class="{ active: isActive('amc') }"
                title="AMC">
                <span class="material-icons-outlined">bar_chart</span>
                <div class="nav-text">AMC</div>
            </router-link>
        </li>
        <li class="nav-item">
            <router-link :to="{ name: 'Migration' }" class="nav-link colorMenu"
                :class="{ active: isActive('migration') }" title="Migration">
                <span class="material-icons-outlined">update</span>
                <div class="nav-text">Migration</div>
            </router-link>
        </li>

        <v-spacer></v-spacer>

        <!--<ul class="navbar-nav">
            <li class="nav-item" v-if="'TAC' === admin">
                <router-link :to="{ name: 'Administration' }" class="nav-link"
                    :class="{ active: isActive('administration') }" title="Administration">
                    <span class="material-icons-outlined">settings</span>
                    <div class="nav-text">Administration</div>
                </router-link>
            </li>
            <li class="nav-item" v-if="'TAC' === admin || 'TMC' === admin">
                <router-link :to="{ name: 'AdministrationOND' }" class="nav-link"
                    :class="{ active: isActive('administrationOND') }" title="AdministrationOND">
                    <span class="material-icons">manage_accounts</span>
                    <div class="nav-text">Administration ON Demand</div>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link :to="{ name: 'DataCatalog' }" class="nav-link" :class="{ active: isActive('DataCatalog') }"
                    title="DataCatalog">
                    <span class="material-icons-outlined">code</span>
                    <div class="nav-text">Data Catalog</div>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link :to="{ name: 'ChatBot' }" class="nav-link" :class="{ active: isActive('ChatBot') }"
                    title="ChatBot">
                    <span class="material-icons-outlined">chat</span>
                    <div class="nav-text">CHATBOT</div>
                </router-link>
            </li>
            </ul>-->

            <li class="nav-item">
                <router-link :to="{ name: 'Alerts' }" class="nav-link" :class="{ active: isActive('alerts') }"
                    title="Alerts">
                    <span class="material-icons">notifications</span>
                    <div class="nav-text">Alerts <span class="number" v-if="alerts">{{ alerts }}</span></div>
                </router-link>
            </li>
            <li class="nav-item">
                <button @click="Disconnect" class="nav-link">
                    <span class="material-icons-outlined">logout</span>
                    <div class="nav-text">Déconnexion</div>
                </button>
            </li>
            
            <!-- <li class="nav-item tooltip">
              <button v-if="isReload == false " class="nav-link" style="padding:0;" 
              @click="clickRefresh">
                  <span class="material-icons md-20" style="padding:5px;">sync</span><div class="nav-text">Synchronisation</div>
              </button>
              <button v-if="isReload == true " class="nav-link" style="padding:0;">
                  <span class="material-icons md-20" style="background-color:gray;border-radius:15px;padding:3px;" >sync</span><div class="nav-text">Synchronisation</div>
              </button>
          </li> -->
        
    </v-app-bar>
</template>

<script>
import axios from "axios";
//  import store from "../store";
export default {
    name: "HeaderComponents",
    props: {},
    methods: {
        handleMouseOver() {
            this.isCollapsed = false;
        },
        handleMouseLeave() {
            this.isCollapsed = true;
        },
        Disconnect: function () {
            localStorage.clear();
            location.reload();
        },
        isActive: function (menuItem) {
            return this.$route.meta.menuActive === menuItem;
        },
        normalizeKpi(kpi) {
            if (kpi && !Array.isArray(kpi.repository.projects.project)) {
                kpi.repository.projects.project = [kpi.repository.projects.project]
            }
            kpi.repository.projects.project.forEach(p => {
                if (!Array.isArray(p.jobs.job)) {
                    p.jobs.job = [p.jobs.job]
                }
                p.jobs.job.forEach(j => {
                    if (!Array.isArray(j.composants.composant)) {
                        j.composants.composant = [j.composants.composant]
                    }
                    j.composants.composant.forEach(c => {
                        if (c.expessions && !Array.isArray(c.expessions.expression)) {
                            c.expessions.expression = [c.expessions.expression]
                        }
                        if (c.rows && !Array.isArray(c.rows.row)) {
                            c.rows.row = [c.rows.row]
                        }
                        if (c.champs && !Array.isArray(c.champs.champ)) {
                            c.champs.champ = [c.champs.champ]
                        }
                    })
                })
            })

            return kpi
        },

        normalizeTransaction(trans) {
            if (trans && !Array.isArray(trans.transaction)) {
                trans.transaction = [trans.transaction]
            }
            return trans
        },
        // clickRefresh(){
        //         this.isReload = true

        //     Promise.all([

        //           axios.get("", { params: { endpoint: "transaction/put", verb: "POST", "data-raw": '{"client":"c1","user":"user1"}' } }),
        //           ])

        //         .then(([transPut]) => {

        //             //console.log(transPut);
        //             if(transPut.data){
        //                 this.transPut = this.normalizeTransaction(transPut.data)
        //                 this.isReload = true

        //                     var idInterval = setInterval(() => {
        //                         Promise.all([
        //                             axios.get("", { params: { endpoint: "transaction/get"} }),
        //                             axios.get("", { params: { endpoint: "transaction/getlast"} })
        //                         ]).then(([transGet,transGetLast]) => {

        //                         if(transGet.data){

        //                                 this.transGet = this.normalizeTransaction(transGet.data)    
        //                                 this.transGetLast = this.normalizeTransaction(transGetLast.data)
        //                                 //console.log(this.transGet)
        //                                 this.isReload = true

        //                         }else{

        //                             this.transGet = "na"
        //                             this.isReload = false
        //                             this.transGetLast = this.normalizeTransaction(transGetLast.data) 
        //                             //console.log(this.transGet)
        //                             clearInterval(idInterval)
        //                         }

        //                     })
        //                     },5000)
        //             }



        //             // loader
        //             this.loading = false
        //         })
        //         .catch(error => {
        //             console.log(error);
        //             this.loading = false
        //         });

        //         return this.isReload
        //     },
    },
    computed: {
        cmptlogrowFlattened2() {
            return this.cmptlogrow ? this.cmptlogrow.repository.projects.project.flatMap(p => {
                return p.jobs.job.flatMap(j => j)
            }) : []
        },
        cmptlogrowSum() {
            return this.cmptlogrow ? this.cmptlogrowFlattened2.map(j => {
                return {
                    name: j.NameJob,
                    yes: j.composants.composant.reduce((previousValue, currentValue) => {
                        const cpt = currentValue.kpi.kpi_value === 1 ? 1 : 0
                        return previousValue + cpt
                    }, 0),
                    no: j.composants.composant.reduce((previousValue, currentValue) => {
                        const cpt = currentValue.kpi.kpi_value === 0 ? 1 : 0
                        return previousValue + cpt
                    }, 0)
                }
            }).sort((a, b) => a.yes >= b.yes ? -1 : 1) : []
        },
        cmpuecFlattened2() {
            return this.cmpuec ? this.cmpuec.repository.projects.project.flatMap(p => {
                return p.jobs.job.flatMap(j => j)
            }) : []
        },
        cmpuecSum() {
            return this.cmpuec ? this.cmpuecFlattened2.map(j => {
                return {
                    name: j.NameJob,
                    yes: j.composants.composant.reduce((previousValue, currentValue) => {
                        const cpt = currentValue.kpi.kpi_value === 1 ? 1 : 0
                        return previousValue + cpt
                    }, 0),
                    no: j.composants.composant.reduce((previousValue, currentValue) => {
                        const cpt = currentValue.kpi.kpi_value === 0 ? 1 : 0
                        return previousValue + cpt
                    }, 0)
                }
            }).sort((a, b) => a.yes >= b.yes ? -1 : 1) : []
        },
        ctxusedFlattened2() {
            return this.ctxused ? this.ctxused.repository.projects.project.flatMap(p => {
                return p.jobs.job.flatMap(j => j)
            }) : []
        },
        ctxusedPercent() {
            return this.ctxused ? this.ctxusedFlattened2.map(j => {
                return {
                    name: j.NameJob,
                    yes: j.composants.composant.reduce((previousValue, currentValue) => {
                        const cpt = currentValue.kpi.kpi_value === true ? 1 : 0
                        return previousValue + cpt
                    }, 0),
                    no: j.composants.composant.reduce((previousValue, currentValue) => {
                        const cpt = currentValue.kpi.kpi_value === false ? 1 : 0
                        return previousValue + cpt
                    }, 0)
                }
            }).sort((a, b) => (a.no / (+a.no + a.yes)) >= (b.no / (+b.no + b.yes)) ? -1 : 1) : []
        },
        cmprefFlattened2() {
            return this.cmpref ? this.cmpref.repository.projects.project.flatMap(p => {
                return p.jobs.job.flatMap(j => j)
            }) : []
        },
        cmprefSum() {
            return this.cmpref ? this.cmprefFlattened2.map(j => {
                return {
                    name: j.NameJob,
                    yes: j.composants.composant.reduce((previousValue, currentValue) => {
                        const cpt = currentValue.kpi.kpi_value === 1 ? 1 : 0
                        return previousValue + cpt
                    }, 0),
                    no: j.composants.composant.reduce((previousValue, currentValue) => {
                        const cpt = currentValue.kpi.kpi_value === 0 ? 1 : 0
                        return previousValue + cpt
                    }, 0)
                }
            }).sort((a, b) => a.yes >= b.yes ? -1 : 1) : []
        },
        cmpcondurFlattened2() {
            return this.cmpcondur ? this.cmpcondur.repository.projects.project.flatMap(p => {
                return p.jobs.job.flatMap(j => j)
            }) : []
        },
        cmpcondurSum() {
            return this.cmpcondur ? this.cmpcondurFlattened2.map(j => {
                return {
                    name: j.NameJob,
                    yes: j.composants.composant.reduce((previousValue, currentValue) => {
                        const cpt = currentValue.kpi.kpi_value === 1 ? 1 : 0
                        return previousValue + cpt
                    }, 0),
                    no: j.composants.composant.reduce((previousValue, currentValue) => {
                        const cpt = currentValue.kpi.kpi_value === 0 ? 1 : 0
                        return previousValue + cpt
                    }, 0)
                }
            }).sort((a, b) => a.yes >= b.yes ? -1 : 1) : []
        },
        alerts() {
            let nbAlerts = 0
            if (this.cmptlogrowSum.some(c => c.yes > 5)) {
                nbAlerts++
            }
            if (this.cmpuecSum.some(c => c.yes > 3)) {
                nbAlerts++
            }
            if (this.ctxusedPercent.some(c => (c.no / (+c.no + c.yes)) > 0.8)) {
                nbAlerts++
            }
            if (this.cmprefSum.some(c => c.yes >= 3)) {
                nbAlerts++
            }
            if (this.cmpcondurSum.some(c => c.yes >= 1)) {
                nbAlerts++
            }
            return nbAlerts
        },
    },

    data() {
        return {
            admin: '',
            loading: false,
            ctxused: null,
            cmpref: null,
            cmpcondur: null,
            cmpdieonchild: null,
            cmptlogrow: null,
            cmpuec: null,
            isCollapsed: true,
            isReload: false,
            menu: false,
            transGet: null,
            transGetLast: { transaction: [] },
            transPut: null
        }
    },

    created() {

        this.loading = true
        Promise.all([
            // CONTEXT
            //axios.get("", { params: { endpoint: "kpisctx/ctxused", verb: "POST", "data-raw": '{"jobs":"","projets":""}' } }),
            //axios.get("", { params: { endpoint: "kpisctx/cmpref", verb: "POST", "data-raw": '{"jobs":"","projets":""}' } }),
            //axios.get("", { params: { endpoint: "kpisctx/cmpcondur", verb: "POST", "data-raw": '{"jobs":"","projets":""}' } }),
            // ORGANISATION
            //axios.get("", { params: { endpoint: "kpisorg/cmpdieonchild", verb: "POST", "data-raw": '{"jobs":"","projets":""}' } }),
            //axios.get("", { params: { endpoint: "kpisorg/cmptlogrow", verb: "POST", "data-raw": '{"jobs":"","projets":""}' } }),
            //axios.get("", { params: { endpoint: "kpisorg/cmpuec", verb: "POST", "data-raw": '{"jobs":"","projets":""}' } }),
            axios.get("", { params: { endpoint: "admin" } })
        ])
            .then(([/*ctxused, cmpref, cmpcondur, cmpdieonchild, cmptlogrow, cmpuec, */admin]) => {
                //         if (ctxused.data.length) {
                //             this.ctxused = this.normalizeKpi(ctxused.data[0])
                //         }
                //         if (cmpref.data.length) {
                //             this.cmpref = this.normalizeKpi(cmpref.data[0])
                //         }
                //         if (cmpcondur.data.length) {
                //             this.cmpcondur = this.normalizeKpi(cmpcondur.data[0])
                //         }
                //         if (cmpdieonchild.data.length) {
                //             this.cmpdieonchild = this.normalizeKpi(cmpdieonchild.data[0])
                //         }
                //         if (cmptlogrow.data.length) {
                //             this.cmptlogrow = this.normalizeKpi(cmptlogrow.data[0])
                //         }
                //         if (cmpuec.data.length) {
                //             this.cmpuec = this.normalizeKpi(cmpuec.data[0])
                //         }
                // admin
                this.admin = admin.data.root.admin
                // loader
                this.loading = false
            })
            .catch(error => {
                console.log(error);
                this.loading = false
            });

        //  if (store.getters.isAuthenticated) {
        //     this.isReload = true
        //     setInterval(() => {
        //         Promise.all([
        //             axios.get("", { params: { endpoint: "transaction/get"} }),
        //             axios.get("", { params: { endpoint: "transaction/getlast"} })
        //         ]).then(([transGet,transGetLast]) => {
        //             if(transGet.data){

        //                     this.transGet = this.normalizeTransaction(transGet.data)    
        //                     this.transGetLast = this.normalizeTransaction(transGetLast.data) 
        //                     //console.log(this.transGet)
        //                     this.isReload = true

        //             }else{

        //                 this.transGet = "na"
        //                 this.transGetLast = this.normalizeTransaction(transGetLast.data)  
        //                 this.isReload = false
        //                 //console.log(this.transGet)
        //             }

        //         })
        //     },5000)
        // }

    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.buttonMenu {
    padding: 0 10px !important;
    margin-top: 20px;
    width: 160px;
    display: flex;
    justify-content: flex-start;
}

.colorMenu {
    color: white;
}

.important-nav-bar {
    width: 156px !important;
    position: relative !important;
    max-width: none;
    left: 14px;
}

.nav-text {
    font-size: small;
    font-weight: bold;
}

.tooltip {
    position: relative;
    cursor: pointer;
    margin-left: 5px;
}

.small-header {
    width: 64px !important;
}

.large-header {
    width: 190px !important;
}

.main-header {
    z-index: 999 !important;
    height: 100% !important;
    overflow: hidden;
    border-right: 5px solid #2B317C;
    background-color: #2B317C !important;
}

.tooltip .tooltiptext {
    visibility: hidden;
    background-color: white;
    border: 1px solid black;
    text-align: center;
    border-radius: 6px;
    padding: 3px;
    position: absolute;
    z-index: 1;
    top: 80%;
    margin-left: -50px;
    //margin: auto;
    font-size: 11px;
    width: auto;
}

.tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent black transparent;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}
</style>
